export const FETCH_TYPES = "FETCH_TYPES";
export const FETCH_PLACEMENT_INFO = "FETCH_PLACEMENT_INFO";
